export default "__VITE_ASSET__F4cZFoZ7__"